module.exports = __webpack_public_path__ + "static/media/29DUNON8.e1901034.jpg";